export default {
  questions: {
    openConversational: {
      openEndPlaceholder: "Sila masukkan teks anda di sini",
      conversationalPlaceholder: "Sila masukkan jawapan anda di sini",
      conversationClosed: "Perbualan ditutup.",
      conversationalDisclaimer: "Soalan susulan akan dijana oleh AI berdasarkan jawapan anda."
    },
    openText: {
      openEndPlaceholder: "Sila masukkan teks anda di sini"
    },
    multiText: {
      fieldPlaceholder: 'Jawapan {number}',
      instruction: 'Taip sekurang-kurangnya {count} jawapan di bawah, satu bagi setiap kotak teks',
      instructionWithoutMinimum: 'Taip jawapan anda di bawah, satu bagi setiap kotak teks',
      minimumEntries: 'Sila masukkan sekurang-kurangnya {count} jawapan untuk meneruskan.',
      unaidedBrandAwareness: {
        fieldPlaceholder: 'Jenama {number}',
        minimumEntries: 'Sila masukkan sekurang-kurangnya {count} jenama untuk meneruskan.'
      }
    },
    multiselect: {
      caption: "Pilih semua yang berkenaan"
    },
    rankOrder: {
      enterRankOrder: "Masukkan susunan keutamaan",
      placeholder: "Seret pilihan anda ke sini untuk menyusun"
    },
    openNumeric: {
      label: "Nombor Terbuka"
    },
    complete: {
      message: "Terima kasih kerana melengkapkan tinjauan ini."
    },
    openVideo: {
      warning: "Sila rakam video sebelum meneruskan.",
      uploadStatusUploading: "Sila tunggu sehingga kami memproses video anda sebelum meneruskan...",
      uploadStatusSuccess: "Muat naik berjaya, anda boleh meneruskan.",
      uploadStatusError: "Muat naik tidak selesai, sila cuba lagi."
    }
  },
  errors: {
    node: {
      text_invalid_email: 'Sila masukkan e-mel yang sah',
      text_invalid_phone: 'Sila masukkan nombor telefon yang sah',
      text_invalid_us_zip: 'Sila masukkan kod ZIP AS yang sah',
      text_invalid_ca_postal: 'Sila masukkan poskod Kanada yang sah',
      text_invalid_uk_postal: 'Sila masukkan poskod UK yang sah',
      text_invalid_custom: 'Sila masukkan {fieldName} yang sah',
      text_min_chars: 'Sila masukkan sekurang-kurangnya {min} aksara',
      text_max_chars: 'Sila masukkan tidak lebih daripada {max} aksara',
      text_alpha_not_allowed: 'Hanya aksara angka dibenarkan',
      text_numeric_not_allowed: 'Hanya aksara abjad dibenarkan'
    },
    external: {
      invalid: 'Jawapan kepada soalan ini tidak sah.',
      required: 'Soalan ini mesti dijawab.',
      singlechoice_required: 'Sila pilih satu pilihan sebelum meneruskan.',
      numeric_required: 'Sila pilih penarafan sebelum meneruskan.',
      text_required: 'Sila masukkan jawapan sebelum meneruskan.',
      bigtext_required: 'Sila masukkan jawapan sebelum meneruskan.',
      singlechoiceother_incomplete: 'Sila masukkan jawapan sebelum meneruskan.',
      multiselectother_incomplete: 'Sila masukkan jawapan sebelum meneruskan.',
      numeric_invalid: 'Sila masukkan nombor yang sah sebelum meneruskan.',
      radiogrid_required: 'Sila pilih pilihan untuk setiap baris sebelum meneruskan.',
      incomplete: 'Sila selesaikan soalan ini sepenuhnya sebelum meneruskan.',
      multiselect_min: 'Sila pilih sekurang-kurangnya {value} pilihan sebelum meneruskan.',
      multiselect_max: 'Sila pilih tidak lebih daripada {value} pilihan sebelum meneruskan.',
      multiselectother_min: 'Sila pilih sekurang-kurangnya {value} pilihan sebelum meneruskan.',
      multiselectother_max: 'Sila pilih tidak lebih daripada {value} pilihan sebelum meneruskan.',
      multiselectgrid_min: 'Sila pilih sekurang-kurangnya {value} pilihan untuk setiap baris sebelum meneruskan.',
      multiselectgrid_max: 'Sila pilih tidak lebih daripada {value} pilihan untuk setiap baris sebelum meneruskan.',
      rankorder_min: 'Sila kedudukan sekurang-kurangnya {value} item sebelum meneruskan.',
      rankorder_max: 'Sila kedudukan tidak lebih daripada {value} item sebelum meneruskan.'
    }
  }
}
